import React, { useState, useEffect } from "react";
import { privacyPolicy } from "../data/data";
import "./CookiesBanner.css";

const CookiesBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showPolicy, setShowPolicy] = useState(false);
  const [policyType, setPolicyType] = useState("short");

  useEffect(() => {
    const consent = localStorage.getItem("cookies-consent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookies-consent", "accepted");
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookies-consent", "declined");
    setShowBanner(false);
  };

  const handleShowPolicy = (type) => {
    setPolicyType(type);
    setShowPolicy(true);
  };

  const handleClosePolicy = () => {
    setShowPolicy(false);
  };

  if (!showBanner && !showPolicy) return null;

  return (
    <>
      {showBanner && (
        <div className="cookies-banner">
          <div className="cookies-content">
            <div className="cookies-text">
              <h3>Polityka Prywatności</h3>
              <p>
                Ta strona używa plików cookie i podobnych technologii, aby
                zapewnić najlepsze doświadczenia użytkownika. Klikając
                "Akceptuję", wyrażasz zgodę na ich użycie.
              </p>
              <div className="cookies-links">
                <button
                  className="cookies-link"
                  onClick={() => handleShowPolicy("short")}>
                  Zobacz skrót polityki
                </button>
                <button
                  className="cookies-link"
                  onClick={() => handleShowPolicy("full")}>
                  Zobacz pełną politykę
                </button>
              </div>
            </div>
            <div className="cookies-actions">
              <button
                className="cookies-btn cookies-btn-decline"
                onClick={handleDecline}>
                Odrzuć
              </button>
              <button
                className="cookies-btn cookies-btn-accept"
                onClick={handleAccept}>
                Akceptuję
              </button>
            </div>
          </div>
        </div>
      )}

      {showPolicy && (
        <div className="policy-overlay" onClick={handleClosePolicy}>
          <div className="policy-modal" onClick={(e) => e.stopPropagation()}>
            <div className="policy-header">
              <h2>{privacyPolicy[policyType].title}</h2>
              <button
                className="policy-close"
                onClick={handleClosePolicy}
                aria-label="Zamknij">
                ×
              </button>
            </div>
            <div className="policy-content">
              {policyType === "short" ? (
                <div className="policy-text">
                  {privacyPolicy.short.content
                    .split("\n")
                    .map((paragraph, index) => (
                      <p key={index}>{paragraph}</p>
                    ))}
                </div>
              ) : (
                <div
                  className="policy-text"
                  dangerouslySetInnerHTML={{
                    __html: privacyPolicy.full.content
                  }}
                />
              )}
            </div>
            <div className="policy-footer">
              <button className="policy-btn" onClick={handleClosePolicy}>
                Zamknij
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CookiesBanner;
